import React, { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Switch } from 'antd';

import { storeName as appStoreName } from '../../../redux/models/app.model';
import { RootState } from '../../../redux/store';

const ThemeSwitch: FC = () => {
  const appDispatch = useDispatch()[appStoreName];
  const themeLight = useSelector<RootState>((state) => state.app.layoutState.themeLight);

  const handleChangeTheme = (value: boolean) => {
    localStorage.setItem('cvta.theme', value ? 'light' : 'dark');
    appDispatch.enableLigthTheme(value);
  };

  return (
    <Switch
      checked={!themeLight}
      onChange={() => handleChangeTheme(!themeLight)}
      checkedChildren={<i className="fas fa-moon fa-sm fa-fw mr-2"></i>}
      unCheckedChildren={<i className="fas fa-sun fa-sm fa-fw mr-2"></i>}
    />
  );
};

export default ThemeSwitch;
